import {assert} from 'Asserts';
import {DataFrame, DataFrameColumnDef, DataFrameRow} from 'data-frames/DataFrameTypes';
import {DataFrameValueAccessor} from 'data-frames/util/createAccessors';
import {makeStructuredTableColumn} from 'notebook/structured-tables/util/StructuredTableColumnUtil';
import {Cell} from 'notebook/tables/constants/CellConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';
import {JSONValue} from 'util/Types';

import {
  DataFrameToTableColumnInfoInitializer,
  BaseColumnConstraint,
  BaseStructuredTableColumn,
} from '../DataFrameTableEditableTypes';

export default function booleanColumnInfoInitializer(
  {displayName, type: {isNullable}}: DataFrameColumnDef,
  _dataFrame: DataFrame,
  baseColumnConstraint: BaseColumnConstraint,
  baseStructuredTableColumn: BaseStructuredTableColumn,
  baseAccessor: DataFrameValueAccessor
): ReturnType<DataFrameToTableColumnInfoInitializer> {
  function rawValueAccessor(row: DataFrameRow): boolean {
    const value = baseAccessor(row);
    if (value == null) {
      return false;
    }

    assert(typeof value === 'boolean', 'Boolean values should always be a boolean');

    return value;
  }

  return {
    columnConstraint: {
      ...baseColumnConstraint,
      columnDefinition: {
        type: TableColumnType.BOOLEAN,
        name: displayName,
        isRequired: !isNullable,
      },
      structuredTableColumn: {
        ...makeStructuredTableColumn({
          ...baseStructuredTableColumn,
          columnType: TableColumnType.BOOLEAN,
        }),
        ...baseStructuredTableColumn,
      },
    },
    dataFrameValueToTableCell: (row: DataFrameRow): Cell => ({
      text: '',
      typedValue: {
        type: BaseTypedValueType.BOOLEAN,
        booleanValue: rawValueAccessor(row),
      },
    }),
    tableCellToDataFrameValue: ({typedValue}: Cell): JSONValue => {
      assert(
        typedValue != null && typedValue.type === BaseTypedValueType.BOOLEAN,
        'Boolean values should always have a typedValue'
      );

      return typedValue.booleanValue;
    },
  };
}
